// src/components/DashboardLayout.js

import React, { useState } from 'react';

import { Outlet, useNavigate, Link } from 'react-router-dom';

import { 

  Box, Drawer, List, ListItem, ListItemButton, ListItemIcon, 

  ListItemText, AppBar, Toolbar, Typography, Button, CssBaseline, IconButton

} from '@mui/material';

import MenuIcon from '@mui/icons-material/Menu';

import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

import MapIcon from '@mui/icons-material/Map';

import AssessmentIcon from '@mui/icons-material/Assessment';

import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';


const drawerWidth = 240;


const DashboardLayout = ({ userRole, onLogout }) => {

  const navigate = useNavigate();

  const [isDrawerOpen, setDrawerOpen] = useState(true);


  const handleDrawerToggle = () => {

    setDrawerOpen(!isDrawerOpen);

  };


  const handleLogoutClick = () => {

    onLogout();

    navigate('/login');

  };


  const menuItems = [

    { text: 'Monitor de Alertas', icon: <NotificationsActiveIcon />, path: '/alertas', admin: false },

    { text: 'Mapa en Vivo', icon: <MapIcon />, path: '/mapa', admin: false },

    { text: 'Reportes', icon: <AssessmentIcon />, path: '/reportes', admin: false },

    { text: 'Administración', icon: <AdminPanelSettingsIcon />, path: '/admin', admin: true },

  ];


  const drawerContent = (

    <div>

      <Toolbar />

      <List>

        {menuItems.map((item) => {

          if (item.admin && userRole !== 'admin') {

            return null;

          }

          return (

            <ListItem key={item.text} disablePadding component={Link} to={item.path} sx={{ color: 'inherit', textDecoration: 'none' }}>

              <ListItemButton>

                <ListItemIcon>{item.icon}</ListItemIcon>

                <ListItemText primary={item.text} />

              </ListItemButton>

            </ListItem>

          );

        })}

      </List>

    </div>

  );


  return (

    <Box sx={{ display: 'flex' }}>

      <CssBaseline />

      <AppBar 

        position="fixed"

        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}

      >

        <Toolbar>

          <IconButton

            color="inherit"

            aria-label="open drawer"

            edge="start"

            onClick={handleDrawerToggle}

            sx={{ mr: 2 }}

          >

            <MenuIcon />

          </IconButton>

          <img 

            src="http://technologistic.com.mx/wp-content/uploads/2025/05/Logo-Technologistic.jpeg"

            alt="Logo" 

            style={{ height: '40px', marginRight: '16px' }} 

          />

          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>

            Plataforma de Monitoreo

          </Typography>

          <Button color="inherit" onClick={handleLogoutClick}>

            Salir

          </Button>

        </Toolbar>

      </AppBar>

      <Drawer

        variant="persistent"

        anchor="left"

        open={isDrawerOpen}

        sx={{

          width: drawerWidth,

          flexShrink: 0,

          '& .MuiDrawer-paper': {

            width: drawerWidth,

            boxSizing: 'border-box',

          },

        }}

      >

        {drawerContent}

      </Drawer>

      <Box

        component="main"

        sx={{ 

          flexGrow: 1, 

          p: 3, 

          transition: (theme) => theme.transitions.create('margin', {

            easing: theme.transitions.easing.sharp,

            duration: theme.transitions.duration.leavingScreen,

          }),

          marginLeft: `-${drawerWidth}px`,

          ...(isDrawerOpen && {

            transition: (theme) => theme.transitions.create('margin', {

              easing: theme.transitions.easing.easeOut,

              duration: theme.transitions.duration.enteringScreen,

            }),

            marginLeft: 0,

          }),

        }}

      >

        <Toolbar /> 

        <Outlet />

      </Box>

    </Box>

  );

};


export default DashboardLayout;
